import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import OfferingHeaderDetails from './offering-header-details';
import { OfferingHeaderShrinkingProps } from './interface';
import { getBookings } from '../../../../services';
import DrawerHeader from '../../../shared/drawer-header';
import useGetEvents from '../../../shared/hook/use-get-events';

const OfferingHeaderShrinking = ({
  scrolled,
  offering,
}: OfferingHeaderShrinkingProps) => {
  const { t } = useTranslation();
  const { maxParticipants, numberOfBookings } = offering;
  const isFullyBooked = maxParticipants <= numberOfBookings;
  const offeringType = offering.type;
  const { data: myBookings } = useQuery(['my-bookings'], getBookings);
  const isBooked = Boolean(
    myBookings?.find(({ offeringId }) => offeringId === offering?.id),
  );
  const { communitySessions } = useGetEvents();

  const isRecommendedEvent = Boolean(
    communitySessions.find(({ id }) => id === offering?.id)?.isRecommended,
  );

  const classes = useStyles({
    offeringType,
  });

  const showBanner = {
    fullyBooked: isFullyBooked,
    booked: isBooked && !isFullyBooked,
    recommended: isRecommendedEvent && !isBooked && !isFullyBooked,
  };

  const items = [
    {
      component: t('v2.global.label_eventFullyBooked'),
      className: classes.fullyBooked,
      show: showBanner.fullyBooked,
    },
    {
      component: t('v2.global.label_eventBooked'),
      className: classes.booked,
      show: showBanner.booked,
    },
    {
      component: t('v2.global.label_recommendedForYou'),
      className: classes.recommended,
      show: showBanner.recommended,
    },
    {
      component: <OfferingHeaderDetails offering={offering} />,
      className: classes.offeringHeader,
      classNameScrolled: classes.offeringHeaderScrolled,
      isPrimaryHeader: true,
    },
  ];

  return <DrawerHeader items={items} scrolled={scrolled} />;
};

export default OfferingHeaderShrinking;
